import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedApps from './components/FeaturedApps';
import CategoryNav from './components/CategoryNav';
import ArticleList from './components/ArticleList';
import FAQSection from './components/FAQSection';

const siteData = {
  name: '体育App指南',
  description: '体育App推荐与下载指南2024 — 寻找最好用的体育App？本页汇集热门体育App下载、功能对比与使用攻略，覆盖赛事直播、运动记录、竞猜互动等核心功能。',
  url: 'https://pvqqe.cn',
};

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    document.title = '体育App推荐与下载指南2024 | 热门体育App下载推荐';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', siteData.description);
    }
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', '体育app,体育app下载,体育app推荐,体育直播app,运动健身app,体育赛事app,足球篮球直播app,体育资讯app');
    }
  }, []);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: siteData.name,
        url: siteData.url,
        description: siteData.description,
      },
      {
        '@type': 'WebSite',
        name: siteData.name,
        url: siteData.url,
        description: siteData.description,
      },
      {
        '@type': 'WebPage',
        name: '体育App推荐与下载指南2024 - 首页',
        url: siteData.url,
        description: siteData.description,
        isPartOf: { '@id': `${siteData.url}#website` },
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '体育App推荐与下载指南网站是做什么的？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '我们是一个专注于体育App推荐与下载指南的专业平台，汇集了市面上热门的体育直播App、运动记录App、竞猜互动App和体育资讯App。',
            },
          },
          {
            '@type': 'Question',
            name: '如何选择适合自己的体育直播App？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '选择体育直播App时，建议从赛事版权、画质体验、解说团队和价格几个维度综合考虑。',
            },
          },
          {
            '@type': 'Question',
            name: '运动记录App的数据准确吗？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '主流运动记录App通过GPS定位和传感器数据采集，在核心指标上已达到较高精度。但建议配合专业运动手表使用。',
            },
          },
          {
            '@type': 'Question',
            name: '这些体育App是否免费？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '大部分推荐的体育App都提供免费基础功能，但高清画质、独家赛事等高级功能通常需要付费会员。',
            },
          },
        ],
      },
    ],
  };

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedApps />
        <CategoryNav />
        <ArticleList />
        <FAQSection />
      </main>
      <Footer />
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
    </>
  );
}